import type { ResellerChargeItem } from '@/api/resellerBilling';

/** A charge that needs the reseller: it failed, or the bank wants the card confirmed. */
export function isOpenCharge(charge: ResellerChargeItem): boolean {
  return charge.status === 'FAILED' || charge.status === 'REQUIRES_ACTION';
}

/**
 * Whether the owner's "Add your card again" applies (TMMAPI-0102: re-verifying is always adding
 * the card again, never removing it) — the bank wants the card confirmed, or there was no card.
 */
export function needsCardAgain(charge: ResellerChargeItem): boolean {
  return (
    charge.status === 'REQUIRES_ACTION' ||
    (charge.status === 'FAILED' &&
      (charge.failureCode === 'NO_CARD' || charge.failureCode === 'REVERIFY_CARD'))
  );
}
